export default {
      id: "lock-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#lock",
      toString: function () {
        return this.url;
      }
    }